module.exports = __webpack_public_path__ + "img/google_us.f043aaef.png";